export default {"src":"/_next/static/media/stiftelsen-sapling-badge-white.82203740.svg","height":353,"width":353,"blurWidth":0,"blurHeight":0};